import React, { useState, useEffect } from 'react';
import ReactPlaceholder from 'react-placeholder';
import PropTypes from 'prop-types';
import {
  H6, H4, Markdown, NoTranslate, BlankLink,
  Row,
  InputPlaceholder
} from '@contently/toolkit';
import { handleError } from '../../utils/errors';
import { get } from '../../../utils/shared/api';
import LocalizedDate from '../toolkit/localized_date';
import AnswerDisplay from '../questions/AnswerDisplay';

const Questions = ({ questions }) => {
  return questions.map(question => {
    return <AnswerDisplay question={question} />;
  });
};

const ShowContentRequest = ({ appData }) => {
  const { contentRequestEndpoint } = JSON.parse(appData);
  const [isFetching, setIsFetching] = useState(true);

  const [contentRequest, setContentRequest] = useState({});

  function getContentRequestData() {
    get(contentRequestEndpoint)
      .then(data => {
        setContentRequest(data);
        setIsFetching(false);
      })
      .catch(errorResponse => {
        handleError(errorResponse, () => handleError(errorResponse));
      });
  }

  useEffect(() => {
    getContentRequestData(contentRequestEndpoint);
  }, [contentRequestEndpoint]);

  const formattedSubmitter = user => {
    return user ? `${user.fullName} (${user.email})` : '';
  };

  const formatDescription = description => {
    if (description) {
      return <Markdown>{description}</Markdown>;
    }

    return 'No description provided';
  };

  const {
    description,
    department,
    formattedDueDate,
    audience,
    pillar,
    file,
    externalUser,
    questions = []
  } = contentRequest;

  return (
    <div className="sub-panel show-details">
      <ReactPlaceholder
        customPlaceholder={<InputPlaceholder withLabel wrapperClass="row" />}
        ready={!isFetching}
      >
        <Row>
          <H6>Submitter</H6>
          <H4>
            <NoTranslate text={formattedSubmitter(externalUser)} />
          </H4>
        </Row>
      </ReactPlaceholder>

      {department && (
        <ReactPlaceholder
          customPlaceholder={<InputPlaceholder withLabel wrapperClass="row" />}
          ready={!isFetching}
        >
          <Row>
            <H6>Department of Submitter</H6>
            <NoTranslate text={department} />
          </Row>
        </ReactPlaceholder>
      )}

      <ReactPlaceholder
        customPlaceholder={<InputPlaceholder withLabel wrapperClass="row" />}
        ready={!isFetching}
      >
        <Row>
          <H6>Description</H6>
          {formatDescription(description)}
        </Row>
      </ReactPlaceholder>

      <ReactPlaceholder
        customPlaceholder={<InputPlaceholder withLabel wrapperClass="row" />}
        ready={!isFetching}
      >
        {formattedDueDate && (
          <Row>
            <H6>Due date</H6>
            <LocalizedDate formatType="datetime" timestamp={formattedDueDate} />
          </Row>
        )}
      </ReactPlaceholder>

      {audience && (
        <ReactPlaceholder
          customPlaceholder={<InputPlaceholder withLabel wrapperClass="row" />}
          ready={!isFetching}
        >
          <Row>
            <H6>Audience</H6>
            <NoTranslate text={audience.name} />
          </Row>
        </ReactPlaceholder>
      )}

      {pillar && (
        <ReactPlaceholder
          customPlaceholder={<InputPlaceholder withLabel wrapperClass="row" />}
          ready={!isFetching}
        >
          <Row>
            <H6>Pillar</H6>
            <NoTranslate text={pillar.name} />
          </Row>
        </ReactPlaceholder>
      )}

      {file && (
        <ReactPlaceholder
          customPlaceholder={<InputPlaceholder withLabel wrapperClass="row" />}
          ready={!isFetching}
        >
          <Row>
            <H6>Additional Materials</H6>
            <BlankLink href={file.url}>
              <NoTranslate text={file.name} />
            </BlankLink>
          </Row>
        </ReactPlaceholder>
      )}

      <Questions questions={questions} />
    </div>
  );
};

ShowContentRequest.propTypes = {
  appData: PropTypes.string.isRequired
};

export default ShowContentRequest;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_requests/show_content_request.jsx